<template>
  <div>
    <navbar/>
    <container/>
  </div>
</template>

<script>
import Nav from "../../Nav";
import Container from "./LinkUteisContainerLista"
export default {
  name: "LinkUteisLista",
  components: {
    "navbar": Nav,
    "container": Container
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/linkUteis/LinkUteisLista.vue